import { render, staticRenderFns } from "./StatisticsNumbers.vue?vue&type=template&id=34f75393&scoped=true"
import script from "./StatisticsNumbers.vue?vue&type=script&lang=js"
export * from "./StatisticsNumbers.vue?vue&type=script&lang=js"
import style0 from "./StatisticsNumbers.vue?vue&type=style&index=0&id=34f75393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f75393",
  null
  
)

export default component.exports